"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
const groupBy = (array, mapFunction) => array.map(typeof mapFunction === 'string' ? (value) => String(value[mapFunction] ?? '') : mapFunction).reduce((accumulator, value, index) => {
    accumulator[value] = (accumulator[value] || []).concat(array[index]);
    return accumulator;
}, {});
exports.groupBy = groupBy;
